import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
font-weight: 300;
background-color: lightgray;
margin: 5px 0;
border-radius: 5px;
width: 100%;
display: flex;
justify-content: space-between;
align-items: center; 
box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15), 0 8px 10px rgba(0, 0, 0, 0.14);

`;
const Button = styled.button`
border: none;
padding: 9px;
border-radius: 5px;
cursor: pointer;
font-size: 10px;
&: hover {
    background-color: #CD919A;
}

`;

const Text = styled.p`
display: inline-block;
flex-grow: 1;
margin: 0 5px;
font-size: 1rem;


`;

const CheckBox = styled.input`
    width: 24px;
    height: 24px;
    margin-left: 5px;
`;

 const ToDoItem = ( props ) => {

    const completedToggle = (event) => {

        return {textDecoration: (props.completed) ? 'line-through' :'none'}
     };


    return (
        <Wrapper className = 'toDoItem'>
            <CheckBox type='checkbox' onChange = {props.completedToggle.bind(this, props.id)} />
            <Text style= {completedToggle()}> {props.text}</Text>
            <Button onClick = {props.deleteItem.bind(this, props.id)}><span className="material-icons">delete_outline</span></Button>
        </ Wrapper>
    );
};

export default ToDoItem;